export const hasDigits = (value, digits) => value.length === digits
